<template>
  <div style="height: 100%;width: 100%">
    <div
      class="echart-line"
      ref="echartsLine"
      v-show="!noData"
    >
    </div>
    <no-data v-show="noData"></no-data>
  </div>
</template>

<script>
/*
   * 折线图 传入参数widgetId 折线图数据id
   * */
import noData from './no-data'
import api from 'api/api'
export default {
  name: 'echart-line',
  props: {
    widgetId: {
      // 折线图数据请求id
      type: String,
      default: ''
    },
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noData: false,
      option: {
        tooltip: {
          trigger: 'axis'
        },
        color: [
          '#6282f7',
          '#fc86ad',
          '#fcb3cc',
          '#fcd7e3',
          '#faac84',
          '#fccf92',
          '#faea9b'
        ],
        legend: {
          right: 0,
          top: 12,
          data: []
        },
        xAxis: {
          type: 'category',
          name: '',
          data: []
        },
        yAxis: {
          type: 'value',
          name: ''
        },
        series: []
      },
      echartObj: null
    }
  },
  mounted () {
    this.init()
    this.loopRefreshWidget()
    window.addEventListener('resize', this.resizeEchart)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeEchart)
    this.echartObj = null
  },
  components: {
    noData
  },
  methods: {
    // 轮巡请求
    loopRefreshWidget () {
      if (this.refreshPeriod !== 0) {
        setInterval(() => {
          this._getData()
        }, this.refreshPeriod * 1000)
      }
    },
    init () {
      this.echartObj = this.$echarts.init(this.$refs.echartsLine)
      this._getData()
    },
    // 获取数据
    _getData () {
      api.widget
        .getData(this.widgetId)
        .then(data => {
          this.option.xAxis.data = data.data.labels || []
          if (this.option.xAxis.data) {
            this.noData = false
          } else {
            this.noData = true
          }
          this.option.series = data.data.values.map(item => {
            item.type = 'line'
            return item
          })
          this.option.legend.data = data.data.values.map(item => {
            return {
              name: item.name,
              icon: 'circle'
            }
          })
          this.echartObj.setOption(this.option)
        })
        .catch(() => {
          this.noData = true
        })
    },
    resizeEchart () {
      this.echartObj.resize()
    }
  },
  watch: {
    widgetId () {
      this.init()
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.echart-line {
  width: 100%;
  height: 100%;
}
</style>
